import { Button, Text } from 'native-base'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { useSubscriptionModal } from '../../context/subscription-modal'

export const SubscriptionCTA = () => {
  const { t } = useTranslation()
  const subscriptionModal = useSubscriptionModal()

  return (
    <Button
      onPress={subscriptionModal.onOpen}
      // TODO: Use theme colors
      bg="#EB445A"
      _hover={{ bg: '#d14459' }}
      _focus={{ bg: '#E3536D' }}
      _pressed={{ bg: '#d14459' }}
      size="xs"
      px={0}
      py={0}
      rounded="sm"
    >
      <Text
        letterSpacing={'1px'}
        fontFamily={'Axiforma'}
        fontWeight="500"
        color={'white'}
        fontSize={'12px'}
        px={'6px'}
        pt={'2px'}
        pb={'0px'}
      >
        {t('subscription.modal.cta.title').toUpperCase()}
      </Text>
    </Button>
  )
}
